const ratings = (state = null, action) => {
  switch (action.type) {
    case 'SET_RATINGS':
      return action.payload;
    default:
      return state;
  }
};

export default ratings;
